/**
 * サーバの応答から、画面へ出してよい文言だけを取り出す。
 *
 * 共通のエラー契約は `message` だけ。ここには利用者向けの日本語が入る。
 *
 * `error` や `detail` は契約外で、次のような経路から内部情報が入り得る。
 *
 * - まだ文言整理の対象になっていないAPI
 * - 旧バージョンのバックエンドが動いている環境
 * - Webサーバ・プロキシ・ライブラリが返すエラー
 * - 独自形式で返している個別Controller
 *
 * 画面に出すのは `message` に限る。無ければ呼び出し側の定型文にする。
 */
export function safeResponseMessage (error, fallback) {
  const data = error && error.response ? error.response.data : null

  if (
    data &&
    typeof data === 'object' &&
    typeof data.message === 'string' &&
    data.message.trim()
  ) {
    return data.message.trim()
  }

  return fallback
}

/**
 * 調査用にconsoleへ残してよい項目だけを抜き出す。
 *
 * axiosのエラーをそのまま渡すと、`config.data` に送信内容が丸ごと入る。
 * 契約企業の連絡先・担当者氏名・SlackチャンネルID・通知本文などが
 * ブラウザのコンソールへ出てしまう。
 *
 * またブラウザのコンソールは運用担当が見られる永続ログではないので、
 * 全文を出しても調査には使えない。判定に要る分だけにする。
 */
export function safeErrorDigest (error) {
  const response = error && error.response ? error.response : null
  if (!response) return { status: 0 }

  const data = response.data && typeof response.data === 'object'
    ? response.data
    : null
  const headers = response.headers || {}

  return {
    status: response.status,
    code: data ? data.code : undefined,
    requestId: headers['x-request-id']
  }
}
